// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"6bdfaf06","877":"4ae414eb"}[chunkId] + ".chunk.css";
};